// ContactCTA.js
import React from 'react';
import { PhoneCall, Mail, ArrowRight } from 'lucide-react';

const ContactCTA = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="bg-gradient-to-r from-[#113262] to-[#1C52A0] rounded-xl shadow-md overflow-hidden">
        <div className="px-6 py-10 sm:px-10 sm:py-12 lg:py-16 flex flex-col md:flex-row items-center justify-between">
          <div className="md:max-w-2xl mb-8 md:mb-0">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">
              Need assistance with your investments?
            </h2>
            <p className="text-[#A2B8D8] text-lg">
              Our investment experts are ready to help you with any questions or concerns.
            </p>
            
          </div>
          
          <a 
            href="/contact-us" 
            className="group inline-flex items-center bg-[#F49611] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#F6A839] transition-colors duration-300"
          >
            Contact Us
            <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactCTA;